const list = {
    or: '또는',
    and: '및',
    separator: ',',
};
export default Object.freeze(list);
